<template>
  <div :class="ns.b()">
    <div
      ref="editorContainer"
      class="editor-container"
      :style="{ height: style.height, width: style.width }"
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import loader from '@monaco-editor/loader'
import { codeEditorProps } from './codeEditor'

defineOptions({
  name: 'LtCodeEditor',
})

const props = defineProps(codeEditorProps)
const ns = useNamespace('codeEditor')
const emits = defineEmits(['update:value'])

const editorContainer = ref<HTMLDivElement | null>(null)
let editorInstance: any = null

onMounted(() => {
  loader.init().then((monaco) => {
    if (editorContainer.value) {
      editorInstance = monaco.editor.create(editorContainer.value, {
        value: props.value || '',
        language: props.language,
        theme: props.theme,
        readOnlyMessage: props.readOnlyMessage.value, //为只读时编辑内日提示词
        readOnly: props.readOnly, // 是否只读内容不可编辑 默认false
        lineNumbers: props.lineNumbers,
        cursorWidth: props.cursorWidth,
        cursorBlinking: props.cursorBlinking,
        automaticLayout: props.automaticLayout,
        roundedSelection: props.roundedSelection,
        scrollBeyondLastLine: props.scrollBeyondLastLine,
        autoClosingBrackets: props.autoClosingBrackets,
        formatOnType: props.formatOnType,
        formatOnPaste: props.formatOnPaste,
        selectionHighlight: props.selectionHighlight,
        fontWeight: props.fontWeight,
        fontSize: props.fontSize,
        lineHeight: props.lineHeight,
        lineDecorationsWidth: props.lineDecorationsWidth,
        lineNumbersMinChars: props.lineNumbersMinChars,
        letterSpacing: props.letterSpacing,
        showUnused: props.showUnused,
      })

      editorInstance.onDidChangeModelContent(() => {
        emits('update:value', editorInstance?.getValue())
      })
    } else {
      console.error('Editor container is not available')
    }
  })
})

onBeforeUnmount(() => {
  if (editorInstance) {
    editorInstance.dispose()
  }
})

watch(
  () => props.language,
  (newLanguage) => {
    if (editorInstance) {
      loader.init().then((monaco) => {
        const model = editorInstance?.getModel()
        if (model) {
          monaco.editor.setModelLanguage(model, newLanguage)
        } else {
          console.error('Editor model is not available')
        }
      })
    }
  }
)
watch(
  () => props.value,
  (newValue) => {
    if (editorInstance && editorInstance.getValue() !== newValue) {
      editorInstance.setValue(newValue as string)
    }
  }
)
</script>
